import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import Auth from '../../utils/Auth';
import { fetchUserProfile } from '../../modules/authentication/redux/actions';
import Forbidden from '../../modules/Forbidden';

const PrivateRoute = ({ actionFetchUser, user, component: Component, ...rest }) => {
  const [isPortalUser, setIsPortalUser] = useState(undefined);

  useEffect(() => {
    if (Object.keys(user).length > 0 && isPortalUser === undefined) {
        if (user?.status) {
            if (user.status.message === 'Unauthorized' && user.status.code === 401) {
                setIsPortalUser(false);
            }
          } else {
              setIsPortalUser(true);
          }
      }
  }, [user, isPortalUser]);

    return (
    <Route {...rest} render={(props) => {
      if (Auth.getInstance().isAuthenticated() === true && isPortalUser === true) {
        return <Component {...props} />;
      }
      if (Auth.getInstance().isAuthenticated() === true && isPortalUser === false) {
        return <Forbidden />;
      }
      return null;
    }}
    />
  );
};

const mapStateToProps = state => ({
   user: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
    actionFetchUser: () => {
        dispatch(fetchUserProfile());
    }
});


export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
